import { useQuery } from "@tanstack/react-query";

import { api, MaritimeForecast } from "@/lib/api";

import { MaritimeForecastDomainId } from "./maritime-forecast.domains";

export type { MaritimeForecast };

const maritimeForecastKeys = {
  forecast: (domainId: MaritimeForecastDomainId) =>
    ["maritimeForecast", "forecast", domainId] as const,
};

export { maritimeForecastKeys };

async function fetchMaritimeForecast(
  domainId: MaritimeForecastDomainId,
): Promise<MaritimeForecast> {
  const { data } = await api.data.getForecastForMaritimeDomain(domainId);
  if (!data) {
    throw new Error(`Maritime forecast not found for domain "${domainId}"`);
  }
  return data;
}

const maritimeForecastQuery = (domainId: MaritimeForecastDomainId) =>
  ({
    queryKey: maritimeForecastKeys.forecast(domainId),
    queryFn: () => fetchMaritimeForecast(domainId),
  }) as const;

export const useMaritimeForecastQuery = (
  domainId: MaritimeForecastDomainId,
  options?: { enabled?: boolean },
) =>
  useQuery({
    ...maritimeForecastQuery(domainId),
    enabled: options?.enabled ?? true,
  });
